




























































































































































































































































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { UserInfo } from "../../_models/userInfo";
import { bus } from "../../main";
import { StudentAssignmentInfo } from "../../_models/studentAssignment";
import * as data from "../../_store/data.module";
import * as user from "../../_store/user.module";

@Component
export default class ConfirmAssignmentDialog extends Vue {
	@Prop() info!: StudentAssignmentInfo;
	@Prop() requestType!: string;
	private dialog: boolean;
	private accept: string;
	private startDate: string;
	private finishDate: string;

	private startDateTemp: string;
	private finishDateTemp: string;
	private currentDateTemp: string;

	private currentDay: string;
	private startTimeMorning: any;
	private finishTimeMorning: any;
	private startTimeAfternoon: any;
	private finishTimeAfternoon: any;
	private startMenu: boolean;
	private finishMenu: boolean;
	private finishTimeMenuMorning: boolean;
	private startTimeMenuMorning: boolean;
	private finishTimeMenuAfternoon: boolean;
	private startTimeMenuAfternoon: boolean;

	private hasSecondPeriod: boolean;
	private startDateSecond: string;
	private finishDateSecond: string;
	private startDateTempSecond: string;
	private finishDateTempSecond: string;
	private startTimeMorningSecond: any;
	private finishTimeMorningSecond: any;
	private startTimeAfternoonSecond: any;
	private finishTimeAfternoonSecond: any;
	private startMenuSecond: boolean;
	private finishMenuSecond: boolean;
	private finishTimeMenuMorningSecond: boolean;
	private startTimeMenuMorningSecond: boolean;
	private finishTimeMenuAfternoonSecond: boolean;
	private startTimeMenuAfternoonSecond: boolean;

	private dateStartingEvent: string;
	private dateFinishingEvent: string;

	private tutorList: any;
	private tutorAziendale: number;
	private facilitazioni: string;

	private responsabilitaCivile: string;
	private assicurazioneAzienda: string;
	private inizioPeriodoUnoMenu: boolean;
	private dataInizioSospensioneUno: string | null;
	private finePeriodoUnoMenu: boolean;
	private dataFineSospensioneUno: string | null;
	private motivazioneSospensioneUno: string;
	private inizioPeriodoDueMenu: boolean;
	private dataInizioSospensioneDue: string | null;
	private finePeriodoDueMenu: boolean;
	private dataFineSospensioneDue: string | null;
	private motivazioneSospensioneDue: string;
	private indennitaMensile: string;

	private startDateRules: [boolean | string];
	private finishDateRules: [boolean | string];
	private startTimeMorningRules: [boolean | string];
	private finishTimeMorningRules: [boolean | string];
	private startTimeAfternoonRules: [boolean | string];
	private finishTimeAfternoonRules: [boolean | string];

	private startDateSecondRules: [boolean | string];
	private finishDateSecondRules: [boolean | string];
	private startTimeMorningSecondRules: [boolean | string];
	private finishTimeMorningSecondRules: [boolean | string];
	private startTimeAfternoonSecondRules: [boolean | string];
	private finishTimeAfternoonSecondRules: [boolean | string];

	private facilitazioniRules: [boolean | string];
	private tutorAziendaleRules: [boolean | string];

	private responsabilitaCivileRules: [boolean | string];
	private assicurazioneAziendaRules: [boolean | string];
	private dataInizioSospensioneUnoRules: [boolean | string];
	private dataFineSospensioneUnoRules: [boolean | string];
	private dataInizioSospensioneDueRule: [boolean | string];
	private dataFineSospensioneDueRules: [boolean | string];
	private motivazioneSospensioneDueRules: [boolean | string];
	private motivazioneSospensioneUnoRules: [boolean | string];
	private indennitaMensileRules: [boolean | string];
	private docDVRRules: [boolean | string];

	private motivazioniSospensione: string[];

	private docDVR: any;

	// private isFormativo: boolean;

	constructor() {
		super();
		this.dialog = false;
		this.accept = "";
		// this.startDate = new Date().toISOString().substr(0, 10);
		// this.finishDate = new Date().toISOString().substr(0, 10);
		this.startDate = "";
		this.finishDate = "";
		this.currentDay = "";
		this.startDateTemp = "";
		this.finishDateTemp = "";
		this.currentDateTemp = new Date().toISOString().substr(0, 10);
		this.startTimeMorning = null;
		this.finishTimeMorning = null;
		this.startTimeAfternoon = null;
		this.finishTimeAfternoon = null;
		this.startMenu = false;
		this.finishMenu = false;
		this.finishTimeMenuMorning = false;
		this.startTimeMenuMorning = false;
		this.finishTimeMenuAfternoon = false;
		this.startTimeMenuAfternoon = false;

		this.hasSecondPeriod = false;
		this.startDateSecond = "";
		this.finishDateSecond = "";
		this.startDateTempSecond = "";
		this.finishDateTempSecond = "";
		this.startTimeMorningSecond = null;
		this.finishTimeMorningSecond = null;
		this.startTimeAfternoonSecond = null;
		this.finishTimeAfternoonSecond = null;
		this.startMenuSecond = false;
		this.finishMenuSecond = false;
		this.finishTimeMenuMorningSecond = false;
		this.startTimeMenuMorningSecond = false;
		this.finishTimeMenuAfternoonSecond = false;
		this.startTimeMenuAfternoonSecond = false;

		this.dateStartingEvent = "";
		this.dateFinishingEvent = "";

		this.tutorList = [];
		this.tutorAziendale = 0;
		this.facilitazioni = "";

		this.responsabilitaCivile = "";
		this.assicurazioneAzienda = "";
		this.inizioPeriodoUnoMenu = false;
		this.dataInizioSospensioneUno = "";
		this.finePeriodoUnoMenu = false;
		this.dataFineSospensioneUno = "";
		this.motivazioneSospensioneUno = "";
		this.inizioPeriodoDueMenu = false;
		this.dataInizioSospensioneDue = "";
		this.finePeriodoDueMenu = false;
		this.dataFineSospensioneDue = "";
		this.motivazioneSospensioneDue = "";
		this.indennitaMensile = "";

		this.startDateRules = [true];
		this.finishDateRules = [true];
		this.startTimeMorningRules = [true];
		this.finishTimeMorningRules = [true];
		this.startTimeAfternoonRules = [true];
		this.finishTimeAfternoonRules = [true];
		this.facilitazioniRules = [true];
		this.tutorAziendaleRules = [true];

		this.startDateSecondRules = [true];
		this.finishDateSecondRules = [true];
		this.startTimeMorningSecondRules = [true];
		this.finishTimeMorningSecondRules = [true];
		this.startTimeAfternoonSecondRules = [true];
		this.finishTimeAfternoonSecondRules = [true];

		this.responsabilitaCivileRules = [true];
		this.assicurazioneAziendaRules = [true];
		this.dataInizioSospensioneUnoRules = [true];
		this.dataFineSospensioneUnoRules = [true];
		this.dataInizioSospensioneDueRule = [true];
		this.dataFineSospensioneDueRules = [true];
		this.motivazioneSospensioneDueRules = [true];
		this.motivazioneSospensioneUnoRules = [true];
		this.indennitaMensileRules = [true];
		this.docDVRRules = [true];

		this.motivazioniSospensione = [
			"Maternità e Paternità obbligatoria",
			"Infortunio",
			"Malattia di lunga durata",
			"Chiusura aziendale"
		];

		this.docDVR = null;


		// this.isFormativo = this.requestType !== 'tirocinioFormativo' && this.requestType !== 'tirocinioReIns'
	}

	@Watch("startDate")
	onStartDateChange() {
		this.dateValidation();
		this.checkOverlap();
	}

	@Watch("finishDate")
	onFinishDateChange() {
		this.dateValidation();
		this.checkOverlap();
	}

	@Watch("startTimeMorning")
	onStartTimeMorningChange() {
		this.timeValidation();
	}

	@Watch("finishTimeMorning")
	onFinishTimeMorningChange() {
		this.timeValidation();
	}

	@Watch("startTimeAfternoon")
	onStartTimeAfternoonChange() {
		this.timeValidation();
	}

	@Watch("finishTimeAfternoon")
	onFinishTimeAfternoonChange() {
		this.timeValidation();
	}

	@Watch("startDateSecond")
	onStartDateSecondChange() {
		this.dateValidationSecond();
		this.checkOverlap();
	}

	@Watch("finishDateSecond")
	onFinishDateSecondChange() {
		this.dateValidationSecond();
		this.checkOverlap();
	}

	@Watch("startTimeMorningSecond")
	onStartTimeMorningSecondChange() {
		this.timeValidationSecond();
	}

	@Watch("finishTimeMorningSecond")
	onFinishTimeMorningSecondChange() {
		this.timeValidationSecond();
	}

	@Watch("startTimeAfternoonSecond")
	onStartTimeAfternoonSecondChange() {
		this.timeValidationSecond();
	}

	@Watch("finishTimeAfternoonSecond")
	onFinishTimeAfternoonSecondChange() {
		this.timeValidationSecond();
	}

	@Watch("startDateTemp")
	onStartDateTempChange() {
		this.startDateFilter();
	}

	@Watch("finishDateTemp")
	onFinishDateTempChange() {
		this.finishDateFilter();
	}

	@Watch("startDateTempSecond")
	onStartDateTempSecondChange() {
		this.startDateSecondFilter();
	}

	@Watch("finishDateTempSecond")
	onFinishDateTempSecondChange() {
		this.finishDateSecondFilter();
	}

	@Watch("dialog")
	onDialogChange(val: boolean) {
		if (val) {
			this.reset();
			this.loadAttivitaFromIscrizioneAzienda();
			
			// Popola i campi se l'allievo ha rifiutato l'orario
			if (this.info.idStatoAccettazioneAllievo == 3) {
				this.accept = "true";
				const startDateISO = this.convertFromLocaleDate(this.info.dataInizioPeriodo);
				const finishDateISO = this.convertFromLocaleDate(this.info.dataFinePeriodo);
				this.startDate = this.convertToLocaleDate(startDateISO);
				this.startDateTemp = startDateISO;
				this.finishDate = this.convertToLocaleDate(finishDateISO);
				this.finishDateTemp = finishDateISO;
				this.startTimeMorning = this.info.orarioInizioMattino;
				this.finishTimeMorning = this.info.orarioFineMattino;
				this.startTimeAfternoon = this.info.orarioInizioPomeriggio;
				this.finishTimeAfternoon = this.info.orarioFinePomeriggio;
				this.tutorAziendale = this.info.idTutorAzienda;
				
				// Popola secondo periodo se esistente
				if (this.info.dataInizioSecondoPeriodo && this.info.dataFineSecondoPeriodo) {
					this.hasSecondPeriod = true;
					const startDateSecondISO = this.convertFromLocaleDate(this.info.dataInizioSecondoPeriodo);
					const finishDateSecondISO = this.convertFromLocaleDate(this.info.dataFineSecondoPeriodo);
					this.startDateSecond = this.convertToLocaleDate(startDateSecondISO);
					this.startDateTempSecond = startDateSecondISO;
					this.finishDateSecond = this.convertToLocaleDate(finishDateSecondISO);
					this.finishDateTempSecond = finishDateSecondISO;
					this.startTimeMorningSecond = this.info.orarioInizioMattinoSecondoPeriodo || null;
					this.finishTimeMorningSecond = this.info.orarioFineMattinoSecondoPeriodo || null;
					this.startTimeAfternoonSecond = this.info.orarioInizioPomeriggioSecondoPeriodo || null;
					this.finishTimeAfternoonSecond = this.info.orarioFinePomeriggioSecondoPeriodo || null;
				}
			}
		}
	}

	dateValidation() {
		let startDateT = new Date(this.startDateTemp)
		let finishDateT = new Date(this.finishDateTemp)
		let currentDateT = new Date(this.currentDateTemp)
		let startEventDate = new Date(this.dateStartingEvent)
		let finishEventDate = new Date(this.dateFinishingEvent)
		if (this.startDate) {
			if (startDateT.getTime() > finishDateT.getTime()) {
				this.startDateRules = [
					"Data di inizio attività maggiore della data di fine attività"
				];
				this.finishDateRules = [
					"Data di fine attività minore della data di inizio attività"
				];
			}
			// else{
			//   this.startDateRules = [true]; 
			// }
			else {
				if ((startDateT.getTime() < startEventDate.getTime()) && (this.requestType !== 'tirocinioFormativo' && this.requestType !== 'tirocinioReIns')) {
					this.startDateRules = ["Data inizio non può essere inferiore al " + this.convertToLocaleDate(this.dateStartingEvent)];
				} else {
					this.startDateRules = [true];
				}
			}
		}
		if (this.finishDate) {
			if (finishDateT.getTime() < startDateT.getTime()) {
				this.finishDateRules = [
					"Data di fine attività minore della data di inizio attività"
				];
			} else if (finishDateT.getTime() < currentDateT.getTime()) {
				this.finishDateRules = ["Data di fine attività minore della data odierna"];
			}
			// else{
			//   this.finishDateRules = [true];
			// }
			else {
				// this.finishDateRules = [true];
				if ((finishDateT.getTime() > finishEventDate.getTime()) && (this.requestType !== 'tirocinioFormativo' && this.requestType !== 'tirocinioReIns')) {
					this.finishDateRules = ["Data fine non può essere maggiore al " + this.convertToLocaleDate(this.dateFinishingEvent)];
				} else {
					this.finishDateRules = [true];
				}
			}
		}
	}

	timeValidation() {
		if (this.startTimeMorning && this.finishTimeMorning) {
			if (this.startTimeMorning >= this.finishTimeMorning) {
				this.startTimeMorningRules = [
					"Ora inizio mattina maggiore o uguale dell'ora fine mattina"
				];
				this.finishTimeMorningRules = [
					"Ora fine mattina minore o uguale dell'ora inizio mattina"
				];
			} else {
				this.startTimeMorningRules = [true];
				this.finishTimeMorningRules = [true];
			}
		}
		if (this.startTimeAfternoon && this.finishTimeAfternoon) {
			if (this.startTimeAfternoon >= this.finishTimeAfternoon) {
				this.startTimeAfternoonRules = [
					"Ora inizio pomeriggio maggiore o uguale dell'ora fine pomeriggio"
				];
				this.finishTimeAfternoonRules = [
					"Ora fine pomeriggio minore o uguale dell'ora inizio pomeriggio"
				];
			} else {
				this.startTimeAfternoonRules = [true];
				this.finishTimeAfternoonRules = [true];
			}
		}
		if (this.finishTimeMorning && this.startTimeAfternoon) {
			if (this.finishTimeMorning > this.startTimeAfternoon) {
				this.finishTimeMorningRules = [
					"Ora fine mattina maggiore dell'ora inizio pomeriggio"
				];
				this.startTimeAfternoonRules = [
					"Ora inizio pomeriggio minore dell'ora fine mattina"
				];
			} else {
				this.finishTimeMorningRules = [true];
				this.startTimeAfternoonRules = [true];
			}
		}
	}

	dateValidationSecond() {
		let startDateT = new Date(this.startDateTempSecond)
		let finishDateT = new Date(this.finishDateTempSecond)
		let currentDateT = new Date(this.currentDateTemp)
		let startEventDate = new Date(this.dateStartingEvent)
		let finishEventDate = new Date(this.dateFinishingEvent)
		if (this.startDateSecond) {
			if (startDateT.getTime() > finishDateT.getTime()) {
				this.startDateSecondRules = [
					"Data di inizio attività maggiore della data di fine attività"
				];
				this.finishDateSecondRules = [
					"Data di fine attività minore della data di inizio attività"
				];
			}
			else {
				if ((startDateT.getTime() < startEventDate.getTime()) && (this.requestType !== 'tirocinioFormativo' && this.requestType !== 'tirocinioReIns')) {
					this.startDateSecondRules = ["Data inizio non può essere inferiore al " + this.convertToLocaleDate(this.dateStartingEvent)];
				} else {
					this.startDateSecondRules = [true];
				}
			}
		}
		if (this.finishDateSecond) {
			if (finishDateT.getTime() < startDateT.getTime()) {
				this.finishDateSecondRules = [
					"Data di fine attività minore della data di inizio attività"
				];
			} else if (finishDateT.getTime() < currentDateT.getTime()) {
				this.finishDateSecondRules = ["Data di fine attività minore della data odierna"];
			}
			else {
				if ((finishDateT.getTime() > finishEventDate.getTime()) && (this.requestType !== 'tirocinioFormativo' && this.requestType !== 'tirocinioReIns')) {
					this.finishDateSecondRules = ["Data fine non può essere maggiore al " + this.convertToLocaleDate(this.dateFinishingEvent)];
				} else {
					this.finishDateSecondRules = [true];
				}
			}
		}
	}

	timeValidationSecond() {
		if (this.startTimeMorningSecond && this.finishTimeMorningSecond) {
			if (this.startTimeMorningSecond >= this.finishTimeMorningSecond) {
				this.startTimeMorningSecondRules = [
					"Ora inizio mattina maggiore o uguale dell'ora fine mattina"
				];
				this.finishTimeMorningSecondRules = [
					"Ora fine mattina minore o uguale dell'ora inizio mattina"
				];
			} else {
				this.startTimeMorningSecondRules = [true];
				this.finishTimeMorningSecondRules = [true];
			}
		}
		if (this.startTimeAfternoonSecond && this.finishTimeAfternoonSecond) {
			if (this.startTimeAfternoonSecond >= this.finishTimeAfternoonSecond) {
				this.startTimeAfternoonSecondRules = [
					"Ora inizio pomeriggio maggiore o uguale dell'ora fine pomeriggio"
				];
				this.finishTimeAfternoonSecondRules = [
					"Ora fine pomeriggio minore o uguale dell'ora inizio pomeriggio"
				];
			} else {
				this.startTimeAfternoonSecondRules = [true];
				this.finishTimeAfternoonSecondRules = [true];
			}
		}
		if (this.finishTimeMorningSecond && this.startTimeAfternoonSecond) {
			if (this.finishTimeMorningSecond > this.startTimeAfternoonSecond) {
				this.finishTimeMorningSecondRules = [
					"Ora fine mattina maggiore dell'ora inizio pomeriggio"
				];
				this.startTimeAfternoonSecondRules = [
					"Ora inizio pomeriggio minore dell'ora fine mattina"
				];
			} else {
				this.finishTimeMorningSecondRules = [true];
				this.startTimeAfternoonSecondRules = [true];
			}
		}
	}

	checkOverlap(){
		if(!this.hasSecondPeriod){
			return;
		}

		let startDateFirst = new Date(this.startDateTemp);
		let finishDateFirst = new Date(this.finishDateTemp);
		let startDateSecond = new Date(this.startDateTempSecond);
		let finishDateSecond = new Date(this.finishDateTempSecond);

		if((startDateFirst <= finishDateSecond) && (startDateSecond <= finishDateFirst)){
			this.startDateRules = ["I periodi inseriti si sovrappongono"];
			this.finishDateRules = ["I periodi inseriti si sovrappongono"];
			this.startDateSecondRules = ["I periodi inseriti si sovrappongono"];
			this.finishDateSecondRules = ["I periodi inseriti si sovrappongono"];
		} else {
			this.startDateRules = [true];
			this.finishDateRules = [true];
			this.startDateSecondRules = [true];
			this.finishDateSecondRules = [true];
		}
	}

	startDateFilter() {
		const date = new Date(this.startDateTemp);
		this.startDate = date.toLocaleString(["it-IT"], {
			day: "2-digit",
			month: "2-digit",
			year: "numeric"
		});
	}

	finishDateFilter() {
		const date = new Date(this.finishDateTemp);
		this.finishDate = date.toLocaleString(["it-IT"], {
			day: "2-digit",
			month: "2-digit",
			year: "numeric"
		});
	}

	startDateSecondFilter() {
		const date = new Date(this.startDateTempSecond);
		this.startDateSecond = date.toLocaleString(["it-IT"], {
			day: "2-digit",
			month: "2-digit",
			year: "numeric"
		});
	}

	finishDateSecondFilter() {
		const date = new Date(this.finishDateTempSecond);
		this.finishDateSecond = date.toLocaleString(["it-IT"], {
			day: "2-digit",
			month: "2-digit",
			year: "numeric"
		});
	}

	convertToLocaleDate(dateString: string): string {
		const date = new Date(dateString);
		return date.toLocaleDateString("it-IT", {
			day: "2-digit",
			month: "2-digit",
			year: "numeric"
		});
	}

	convertFromLocaleDate(dateString: string): string {
		// Converte da formato italiano DD/MM/YYYY a formato ISO YYYY-MM-DD
		if (!dateString) return "";
		const parts = dateString.split("/");
		if (parts.length === 3) {
			return `${parts[2]}-${parts[1]}-${parts[0]}`;
		}
		return dateString;
	}

	validazioneDataInizio() {
		if (this.startDate !== null && this.startDate !== "") {

			this.startDateRules = [true];
			let startDateTmp = new Date(this.startDateTemp)
			let firstDate = new Date(this.dateStartingEvent)
			if ((startDateTmp < firstDate) && (this.requestType !== 'tirocinioFormativo' && this.requestType !== 'tirocinioReIns')) {
				this.startDateRules = ["Data inizio non può essere inferiore al " + this.convertToLocaleDate(this.dateStartingEvent)];
			} else {
				this.startDateRules = [true];
			}
		} else {
			this.startDateRules = ["Data inizio attività necessaria"];
		}
	}

	validazioneDataFine() {
		if (this.finishDate !== null && this.finishDate !== "") {
			this.finishDateRules = [true];
			let endDateTmp = new Date(this.finishDateTemp)
			let lastDate = new Date(this.dateFinishingEvent)
			if ((endDateTmp > lastDate) && (this.requestType !== 'tirocinioFormativo' && this.requestType !== 'tirocinioReIns')) {
				this.finishDateRules = ["Data fine non può essere più grande del " + this.convertToLocaleDate(this.dateFinishingEvent)];
			} else {
				this.finishDateRules = [true]
			}
		} else {
			this.finishDateRules = ["Data fine attività necessaria"];
		}
	}

	validazioneOraInizioMattino() {
		if (this.startTimeMorning !== null && this.startTimeMorning !== "") {
			this.startTimeMorningRules = [true];
		} else {
			this.startTimeMorningRules = ["Ora inizio mattina necessaria"];
		}
	}

	validazioneOraFineMattino() {
		if (this.finishTimeMorning !== null && this.finishTimeMorning !== "") {
			this.finishTimeMorningRules = [true];
		} else {
			this.finishTimeMorningRules = ["Ora fine mattina necessaria"];
		}
	}

	validazioneOraInizioPomeriggio() {
		if (this.startTimeAfternoon !== null && this.startTimeAfternoon !== "") {
			this.startTimeAfternoonRules = [true];
		} else {
			this.startTimeAfternoonRules = ["Ora inizio pomeriggio necessaria"];
		}
	}

	validazioneOraFinePomeriggio() {
		if (this.finishTimeAfternoon !== null && this.finishTimeAfternoon !== "") {
			this.finishTimeAfternoonRules = [true];
		} else {
			this.finishTimeAfternoonRules = ["Ora fine pomeriggio necessaria"];
		}
	}

	validazioneOraInizioMattinoSecondo() {
		if (!this.hasSecondPeriod) {
			this.startTimeMorningSecondRules = [true];
			return;
		}
		if (this.startTimeMorningSecond !== null && this.startTimeMorningSecond !== "") {
			this.startTimeMorningSecondRules = [true];
		} else {
			this.startTimeMorningSecondRules = ["Ora inizio mattina necessaria per il secondo periodo"];
		}
	}

	validazioneOraFineMattinoSecondo() {
		if (!this.hasSecondPeriod) {
			this.finishTimeMorningSecondRules = [true];
			return;
		}
		if (this.finishTimeMorningSecond !== null && this.finishTimeMorningSecond !== "") {
			this.finishTimeMorningSecondRules = [true];
		} else {
			this.finishTimeMorningSecondRules = ["Ora fine mattina necessaria per il secondo periodo"];
		}
	}

	validazioneOraInizioPomeriggioSecondo() {
		if (!this.hasSecondPeriod) {
			this.startTimeAfternoonSecondRules = [true];
			return;
		}
		if (this.startTimeAfternoonSecond !== null && this.startTimeAfternoonSecond !== "") {
			this.startTimeAfternoonSecondRules = [true];
		} else {
			this.startTimeAfternoonSecondRules = ["Ora inizio pomeriggio necessaria per il secondo periodo"];
		}
	}

	validazioneOraFinePomeriggioSecondo() {
		if (!this.hasSecondPeriod) {
			this.finishTimeAfternoonSecondRules = [true];
			return;
		}
		if (this.finishTimeAfternoonSecond !== null && this.finishTimeAfternoonSecond !== "") {
			this.finishTimeAfternoonSecondRules = [true];
		} else {
			this.finishTimeAfternoonSecondRules = ["Ora fine pomeriggio necessaria per il secondo periodo"];
		}
	}

	toggleSecondPeriod() {
		if (!this.hasSecondPeriod) {
			this.hasSecondPeriod = false;
			this.startDateSecond = "";
			this.finishDateSecond = "";
			this.startDateTempSecond = "";
			this.finishDateTempSecond = "";
			this.startTimeMorningSecond = null;
			this.finishTimeMorningSecond = null;
			this.startTimeAfternoonSecond = null;
			this.finishTimeAfternoonSecond = null;
			this.startMenuSecond = false;
			this.finishMenuSecond = false;
			this.finishTimeMenuMorningSecond = false;
			this.startTimeMenuMorningSecond = false;
			this.finishTimeMenuAfternoonSecond = false;
			this.startTimeMenuAfternoonSecond = false;

			this.startDateSecondRules = [true];
			this.finishDateSecondRules = [true];
			this.startTimeMorningSecondRules = [true];
			this.finishTimeMorningSecondRules = [true];
			this.startTimeAfternoonSecondRules = [true];
			this.finishTimeAfternoonSecondRules = [true];
		}
	}

	validazioneFacilitazioni() {
		var valid = false;
		if (this.facilitazioni !== "") {
			valid = /^[a-zA-Zìèéùòà'\x20]{2,250}$/.test(this.facilitazioni);
			if (valid) {
				this.facilitazioniRules = [true];
			} else {
				this.facilitazioniRules = [
					"Il campo non deve contenere numeri o caratteri speciali e non deve superare i 250 caratteri"
				];
			}
		} else {
			this.facilitazioniRules = [true];
		}
	}

	validazioneTutorAziendale() {
		if (this.tutorAziendale !== 0) {
			this.tutorAziendaleRules = [true];
		} else {
			this.tutorAziendaleRules = ["Tutor aziendale necessario"];
		}
	}

	validazioneResponsabilitàCivile() {
		var valid = false;
		if (this.responsabilitaCivile !== "") {
			valid = /^[a-zA-Z0-9/ìèéùòà'\x20]{2,30}$/.test(this.responsabilitaCivile);
			if (valid) {
				this.responsabilitaCivileRules = [true];
			} else {
				this.responsabilitaCivileRules = [
					"Il campo non deve contenere caratteri speciali e non deve superare i 30 caratteri"
				];
			}
		} else {
			this.responsabilitaCivileRules = ["Responsabilità civile necessaria"];
		}
	}

	validazioneAssicurazioneAzienda() {
		var valid = false;
		if (this.assicurazioneAzienda !== "") {
			valid = /^[a-zA-Z0-9/ìèéùòà'\x20]{2,50}$/.test(this.assicurazioneAzienda);
			if (valid) {
				this.assicurazioneAziendaRules = [true];
			} else {
				this.assicurazioneAziendaRules = [
					"Il campo non deve contenere caratteri speciali e non deve superare i 50 caratteri"
				];
			}
		} else {
			this.assicurazioneAziendaRules = ["Nome Assicurazione necessaria"];
		}
	}

	validazioneDataInizioSospensioneUno() {
		if (this.dataInizioSospensioneUno !== "") {
			this.dataInizioSospensioneUnoRules = [true];
		} else {
			this.dataInizioSospensioneUnoRules = [true];
		}
	}

	validazioneDataFineSospensioneUno() {
		if (this.dataFineSospensioneUno !== "") {
			this.dataFineSospensioneUnoRules = [true];
		} else {
			this.dataFineSospensioneUnoRules = [true];
		}
	}

	validazioneSospensioneUno() {
		if (
			this.dataInizioSospensioneUno !== "" ||
			this.dataFineSospensioneUno !== ""
		) {
			if (this.dataInizioSospensioneUno === "") {
				this.dataInizioSospensioneUnoRules = [
					"Data inizio sospensione necessaria"
				];
			}
			if (this.dataFineSospensioneUno === "") {
				this.dataFineSospensioneUnoRules = ["Data fine sospensione necessaria"];
			}
		} else {
			this.dataInizioSospensioneUnoRules = [true];
			this.dataFineSospensioneUnoRules = [true];
		}
	}

	validazioneMotivazioneUno() {
		if (
			this.motivazioneSospensioneUno === "" &&
			this.dataFineSospensioneUno !== ""
		) {
			this.motivazioneSospensioneUnoRules = [
				"Motivazione sospensione necessaria"
			];
		} else {
			this.motivazioneSospensioneUnoRules = [true];
		}
	}

	validazioneDataInizioSospensioneDue() {
		if (this.dataInizioSospensioneDue !== "") {
			this.dataInizioSospensioneDueRule = [true];
		} else {
			this.dataInizioSospensioneDueRule = [true];
		}
	}

	validazioneDataFineSospensioneDue() {
		if (this.dataFineSospensioneDue !== "") {
			this.dataFineSospensioneDueRules = [true];
		} else {
			this.dataFineSospensioneDueRules = [true];
		}
	}

	validazioneSospensioneDue() {
		if (
			this.dataInizioSospensioneDue !== "" ||
			this.dataFineSospensioneDue !== ""
		) {
			if (this.dataInizioSospensioneDue === "") {
				this.dataInizioSospensioneDueRule = [
					"Data inizio sospensione necessaria"
				];
			}
			if (this.dataFineSospensioneDue === "") {
				this.dataFineSospensioneDueRules = ["Data fine sospensione necessaria"];
			}
		} else {
			this.dataInizioSospensioneDueRule = [true];
			this.dataFineSospensioneDueRules = [true];
		}
	}

	validazioneMotivazioneDue() {
		if (
			this.motivazioneSospensioneDue === "" &&
			this.dataFineSospensioneDue !== ""
		) {
			this.motivazioneSospensioneDueRules = [
				"Motivazione sospensione necessaria"
			];
		} else {
			this.motivazioneSospensioneDueRules = [true];
		}
	}

	validazioneDocDVR() {
		if (this.requestType === "alternanza") {
			// Se l'allievo ha rifiutato (stato 3), il DVR non è obbligatorio
			if (this.info.idStatoAccettazioneAllievo == 3) {
				this.docDVRRules = [true];
			} else if (this.docDVR === null || this.docDVR === undefined) {
				this.docDVRRules = ["Documento DVR obbligatorio per l'FSL Estiva"];
			} else if (this.docDVR.type !== "application/pdf") {
				this.docDVRRules = ["Il documento DVR deve essere in formato PDF"];
			} else {
				this.docDVRRules = [true];
			}
		} else {
			this.docDVRRules = [true];
		}
	}

	validazioneDataInizioSecondo() {
		if (!this.hasSecondPeriod) {
			this.startDateSecondRules = [true];
			return;
		}
		if (this.startDateSecond !== null && this.startDateSecond !== "") {
			this.startDateSecondRules = [true];
		} else {
			this.startDateSecondRules = ["Data inizio secondo periodo necessaria"];
		}
	}

	validazioneDataFineSecondo() {
		if (!this.hasSecondPeriod) {
			this.finishDateSecondRules = [true];
			return;
		}
		if (this.finishDateSecond !== null && this.finishDateSecond !== "") {
			this.finishDateSecondRules = [true];
		} else {
			this.finishDateSecondRules = ["Data fine secondo periodo necessaria"];
		}
	}

	async executeTestTirEstivi() {
		// this.validazioneDataInizio();
		// this.validazioneDataFine();
		this.validazioneOraInizioMattino();
		this.validazioneOraFineMattino();
		this.validazioneOraInizioPomeriggio();
		this.validazioneOraFinePomeriggio();
		this.validazioneFacilitazioni();
		this.validazioneTutorAziendale();
		this.validazioneDocDVR();
		if (this.hasSecondPeriod) {
			this.validazioneDataInizioSecondo();
			this.validazioneDataFineSecondo();
			this.validazioneOraInizioMattinoSecondo();
			this.validazioneOraFineMattinoSecondo();
			this.validazioneOraInizioPomeriggioSecondo();
			this.validazioneOraFinePomeriggioSecondo();
		}
	}

	async executeTestTirFormativi() {
		// this.validazioneDataInizio();
		// this.validazioneDataFine();
		this.validazioneOraInizioMattino();
		this.validazioneOraFineMattino();
		this.validazioneOraInizioPomeriggio();
		this.validazioneOraFinePomeriggio();
		this.validazioneFacilitazioni();
		this.validazioneTutorAziendale();
		this.validazioneResponsabilitàCivile();
		this.validazioneAssicurazioneAzienda();
		this.validazioneSospensioneUno();
		this.validazioneMotivazioneUno();
		this.validazioneSospensioneDue();
		this.validazioneMotivazioneDue();
	}

	save(idRichiesta: number) {
		var payload = {
			idRichiesta: idRichiesta,
			attivita: this.requestType
		};
		var payload2 = {
			emailTutorArticolazione: "",
			denominazioneAzienda: "",
			tirocinante: "",
			activityType: "",
			statusAccettazione: ""
		};

		if (this.requestType === "tirocinioEstivo") {
			this.executeTestTirEstivi().then(() => {
				if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
					var infoTirocinio = {
						dataInizioPeriodo: this.startDateTemp,
						dataFinePeriodo: this.finishDateTemp,
						oraInizioMattino: this.startTimeMorning,
						oraFineMattino: this.finishTimeMorning,
						oraInizioPomeriggio: this.startTimeAfternoon,
						oraFinePomeriggio: this.finishTimeAfternoon,
						idTutorAziendale: this.tutorAziendale,
						facilitazioni: this.facilitazioni,
						idRichiesta: idRichiesta,
						attivita: this.requestType
					};
					user
						.dispatchUpdatePreAssegnamentoTirEstivo(
							this["$store"],
							infoTirocinio
						)
						.then(() => {
							bus.$emit(
								"successfullOperation",
								"Attendere la conferma dell'Assegnazione da parte dell'Istituto"
							);
							bus.$emit("loadPreAssegnazioni");
							this.cancel();
							data
								.dispatchDetailsAbbinamentoAllievoAzienda(
									this["$store"],
									payload
								)
								.then(result => {
									payload2 = {
										emailTutorArticolazione: result.EmailTutorArticolazione,
										denominazioneAzienda: result.Denominazione,
										tirocinante: result.Cognome + " " + result.Nome,
										activityType: this.requestType,
										statusAccettazione: "accettato"
									};
									user
										.dispatchSendEmailAbbinamentoCompletato(
											this["$store"],
											payload2
										)
										.then(() => {
											this.cancel();
										})
										.catch(error => {
											if (error.response.status === 403) {
												bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
												this["$router"].push("/login");
											} else {
												bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
											}
										});
								})
								.catch(error => {
									if (error.response.status === 403) {
										bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
										this["$router"].push("/login");
									} else {
										bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
									}
								});
						})
						.catch(error => {
							if (error.response.status === 403) {
								bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
								this["$router"].push("/login");
							} else {
								bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
							}
						});
				}
			});
		} else if (this.requestType === "alternanza") {
			this.executeTestTirEstivi().then(() => {
				if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
					// Controllo durata minima di 2 settimane
					const startDate = new Date(this.startDateTemp);
					const finishDate = new Date(this.finishDateTemp);
					const firstPeriodDays = Math.floor((finishDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;
					
					let totalDays = firstPeriodDays;
					
					if (this.hasSecondPeriod) {
						const startDateSecond = new Date(this.startDateTempSecond);
						const finishDateSecond = new Date(this.finishDateTempSecond);
						const secondPeriodDays = Math.floor((finishDateSecond.getTime() - startDateSecond.getTime()) / (1000 * 60 * 60 * 24)) + 1;
						totalDays += secondPeriodDays;
					}
					
					if (totalDays < 12) {
						bus.$emit("errorOperation", "La durata totale dell'attività deve essere di almeno 2 settimane (12 giorni)");
						return;
					}
					
					var infoTirocinio: any = {
						dataInizioPeriodo: this.startDateTemp,
						dataFinePeriodo: this.finishDateTemp,
						oraInizioMattino: this.startTimeMorning,
						oraFineMattino: this.finishTimeMorning,
						oraInizioPomeriggio: this.startTimeAfternoon,
						oraFinePomeriggio: this.finishTimeAfternoon,
						idTutorAziendale: this.tutorAziendale,
						facilitazioni: this.facilitazioni,
						idRichiesta: idRichiesta,
						attivita: this.requestType
					};

					if (this.hasSecondPeriod) {
						infoTirocinio.hasSecondPeriod = true;
						infoTirocinio.dataInizioSecondoPeriodo = this.startDateTempSecond;
						infoTirocinio.dataFineSecondoPeriodo = this.finishDateTempSecond;
						infoTirocinio.oraInizioMattinoSecondoPeriodo = this.startTimeMorningSecond;
						infoTirocinio.oraFineMattinoSecondoPeriodo = this.finishTimeMorningSecond;
						infoTirocinio.oraInizioPomeriggioSecondoPeriodo = this.startTimeAfternoonSecond;
						infoTirocinio.oraFinePomeriggioSecondoPeriodo = this.finishTimeAfternoonSecond;
					} else {
						infoTirocinio.hasSecondPeriod = false;
					}

					user
						.dispatchUpdatePreAssegnamentoAlternanza(
							this["$store"],
							infoTirocinio
						)
						.then(async () => {
							// Carica DVR solo se non è un rifiuto dell'allievo (stato 3)
							if (this.info.idStatoAccettazioneAllievo != 3) {
								var base64DocDVR = "";
								if (this.docDVR) {
									base64DocDVR = await this.convertToBase64(this.docDVR);
								}

								await user.dispatchUploadDocDVR(this["$store"], { base64: base64DocDVR, idRichiesta: idRichiesta });
							}

							bus.$emit(
								"successfullOperation",
								"Attendere la conferma dell'Assegnazione da parte dell'Istituto"
							);
							bus.$emit("loadPreAssegnazioni");
							this.cancel();
							data
								.dispatchDetailsAbbinamentoAllievoAzienda(
									this["$store"],
									payload
								)
								.then(result => {
									payload2 = {
										emailTutorArticolazione: result.EmailTutorArticolazione,
										denominazioneAzienda: result.Denominazione,
										tirocinante: result.Cognome + " " + result.Nome,
										activityType: this.requestType,
										statusAccettazione: "accettato"
									};
									user
										.dispatchSendEmailAbbinamentoCompletato(
											this["$store"],
											payload2
										)
										.then(() => {
											this.cancel();
										})
										.catch(error => {
											if (error.response.status === 403) {
												bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
												this["$router"].push("/login");
											} else {
												bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
											}
										});
								})
								.catch(error => {
									if (error.response.status === 403) {
										bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
										this["$router"].push("/login");
									} else {
										bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
									}
								});

						})
						.catch(error => {
							if (error.response.status === 403) {
								bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
								this["$router"].push("/login");
							} else {
								bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
							}
						});
				}
			});
		} else if (this.requestType === "tirocinioFormativo") {
			this.executeTestTirFormativi().then(() => {
				if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
					if (
						this.dataInizioSospensioneUno === "" ||
						this.dataFineSospensioneUno === ""
					) {
						this.dataInizioSospensioneUno = null;
						this.dataFineSospensioneUno = null;
						this.motivazioneSospensioneUno = "";
					}
					if (
						this.dataInizioSospensioneDue === "" ||
						this.dataFineSospensioneDue === ""
					) {
						this.dataInizioSospensioneDue = null;
						this.dataFineSospensioneDue = null;
						this.motivazioneSospensioneDue = "";
					}

					var infoTirocinio = {
						dataInizioPeriodo: this.startDateTemp,
						dataFinePeriodo: this.finishDateTemp,
						oraInizioMattino: this.startTimeMorning,
						oraFineMattino: this.finishTimeMorning,
						oraInizioPomeriggio: this.startTimeAfternoon,
						oraFinePomeriggio: this.finishTimeAfternoon,
						idTutorAziendale: this.tutorAziendale,
						facilitazioni: this.facilitazioni,
						idRichiesta: idRichiesta,
						attivita: this.requestType,
						responsabilitaCivile: this.responsabilitaCivile,
						assicurazioneAzienda: this.assicurazioneAzienda,
						indennitaMensile: this.indennitaMensile,
						dataInizioSospensioneUno: this.dataInizioSospensioneUno,
						dataFineSospensioneUno: this.dataFineSospensioneUno,
						motivazioneSospensioneUno: this.motivazioneSospensioneUno,
						dataInizioSospensioneDue: this.dataInizioSospensioneDue,
						dataFineSospensioneDue: this.dataFineSospensioneDue,
						motivazioneSospensioneDue: this.motivazioneSospensioneDue
					};

					user
						.dispatchUpdatePreAssegnamentoTirFormativo(
							this["$store"],
							infoTirocinio
						)
						.then(() => {
							bus.$emit(
								"successfullOperation",
								"Attendere la conferma dell'Assegnazione da parte dell'Istituto"
							);
							bus.$emit("loadPreAssegnazioni");
							data
								.dispatchDetailsAbbinamentoAllievoAzienda(
									this["$store"],
									payload
								)
								.then(result => {
									payload2 = {
										emailTutorArticolazione: result.EmailTutorArticolazione,
										denominazioneAzienda: result.Denominazione,
										tirocinante: result.Cognome + " " + result.Nome,
										activityType: this.requestType,
										statusAccettazione: "accettato"
									};
									user
										.dispatchSendEmailAbbinamentoCompletato(
											this["$store"],
											payload2
										)
										.then(() => {
											this.cancel();
										})
										.catch(error => {
											if (error.response.status === 403) {
												bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
												this["$router"].push("/login");
											} else {
												bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
											}
										});
								})
								.catch(error => {
									if (error.response.status === 403) {
										bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
										this["$router"].push("/login");
									} else {
										bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
									}
								});
						})
						.catch(error => {
							if (error.response.status === 403) {
								bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
								this["$router"].push("/login");
							} else {
								bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
							}
						});
				}
			});
		} else if (this.requestType === "tirocinioReIns") {
			this.executeTestTirFormativi().then(() => {
				if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
					if (
						this.dataInizioSospensioneUno === "" ||
						this.dataFineSospensioneUno === ""
					) {
						this.dataInizioSospensioneUno = null;
						this.dataFineSospensioneUno = null;
						this.motivazioneSospensioneUno = "";
					}
					if (
						this.dataInizioSospensioneDue === "" ||
						this.dataFineSospensioneDue === ""
					) {
						this.dataInizioSospensioneDue = null;
						this.dataFineSospensioneDue = null;
						this.motivazioneSospensioneDue = "";
					}

					var infoTirocinio = {
						dataInizioPeriodo: this.startDateTemp,
						dataFinePeriodo: this.finishDateTemp,
						oraInizioMattino: this.startTimeMorning,
						oraFineMattino: this.finishTimeMorning,
						oraInizioPomeriggio: this.startTimeAfternoon,
						oraFinePomeriggio: this.finishTimeAfternoon,
						idTutorAziendale: this.tutorAziendale,
						facilitazioni: this.facilitazioni,
						idRichiesta: idRichiesta,
						attivita: this.requestType,
						responsabilitaCivile: this.responsabilitaCivile,
						assicurazioneAzienda: this.assicurazioneAzienda,
						indennitaMensile: this.indennitaMensile,
						dataInizioSospensioneUno: this.dataInizioSospensioneUno,
						dataFineSospensioneUno: this.dataFineSospensioneUno,
						motivazioneSospensioneUno: this.motivazioneSospensioneUno,
						dataInizioSospensioneDue: this.dataInizioSospensioneDue,
						dataFineSospensioneDue: this.dataFineSospensioneDue,
						motivazioneSospensioneDue: this.motivazioneSospensioneDue
					};
					user
						.dispatchUpdatePreAssegnamentoTirReIns(
							this["$store"],
							infoTirocinio
						)
						.then(() => {
							bus.$emit(
								"successfullOperation",
								"Attendere la conferma dell'Assegnazione da parte dell'Istituto"
							);
							bus.$emit("loadPreAssegnazioni");
							data
								.dispatchDetailsAbbinamentoAllievoAzienda(
									this["$store"],
									payload
								)
								.then(result => {
									payload2 = {
										emailTutorArticolazione: result.EmailTutorArticolazione,
										denominazioneAzienda: result.Denominazione,
										tirocinante: result.Cognome + " " + result.Nome,
										activityType: this.requestType,
										statusAccettazione: "accettato"
									};
									user
										.dispatchSendEmailAbbinamentoCompletato(
											this["$store"],
											payload2
										)
										.then(() => {
											this.cancel();
										})
										.catch(error => {
											if (error.response.status === 403) {
												bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
												this["$router"].push("/login");
											} else {
												bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
											}
										});
								})
								.catch(error => {
									if (error.response.status === 403) {
										bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
										this["$router"].push("/login");
									} else {
										bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
									}
								});
						})
						.catch(error => {
							if (error.response.status === 403) {
								bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
								this["$router"].push("/login");
							} else {
								bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
							}
						});
				}
			});
		}
	}

	refuse(idRichiesta: number) {
		var payload = {
			idRichiesta: idRichiesta,
			attivita: this.requestType
		};

		var payload2 = {
			emailTutorArticolazione: "",
			denominazioneAzienda: "",
			tirocinante: "",
			activityType: "",
			statusAccettazione: ""
		};
		if (confirm("Rifiutare il pre-Abbinamento?")) {
			user
				.dispatchRefusePreAbbinamento(this["$store"], payload)
				.then(() => {
					bus.$emit(
						"successfullOperation",
						"Pre Abbinamento rifiutato con successo"
					);
					bus.$emit("loadPreAssegnazioni");
					data
						.dispatchDetailsAbbinamentoAllievoAzienda(this["$store"], payload)
						.then(result => {
							payload2 = {
								emailTutorArticolazione: result.EmailTutorArticolazione,
								denominazioneAzienda: result.Denominazione,
								tirocinante: result.Cognome + " " + result.Nome,
								activityType: this.requestType,
								statusAccettazione: "rifiutato"
							};
							user
								.dispatchSendEmailAbbinamentoCompletato(
									this["$store"],
									payload2
								)
								.then(() => {
									this.cancel();
								})
								.catch(error => {
									if (error.response.status === 403) {
										bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
										this["$router"].push("/login");
									} else {
										bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
									}
								});
						})
						.catch(error => {
							if (error.response.status === 403) {
								bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
								this["$router"].push("/login");
							} else {
								bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
							}
						});
				})
				.catch(error => {
					if (error.response.status === 403) {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
						this["$router"].push("/login");
					} else {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					}
				});
		}
	}

	cancel() {
		this.dialog = false;
		this.accept = "";
		this.startDate = "";
		this.finishDate = "";
		this.currentDay = "";
		this.startDateTemp = "";
		this.finishDateTemp = "";
		this.currentDateTemp = new Date().toISOString().substr(0, 10);
		this.startTimeMorning = null;
		this.finishTimeMorning = null;
		this.startTimeAfternoon = null;
		this.finishTimeAfternoon = null;
		this.startMenu = false;
		this.finishMenu = false;
		this.finishTimeMenuMorning = false;
		this.startTimeMenuMorning = false;
		this.finishTimeMenuAfternoon = false;
		this.startTimeMenuAfternoon = false;

		this.hasSecondPeriod = false;
		this.startDateSecond = "";
		this.finishDateSecond = "";
		this.startDateTempSecond = "";
		this.finishDateTempSecond = "";
		this.startTimeMorningSecond = null;
		this.finishTimeMorningSecond = null;
		this.startTimeAfternoonSecond = null;
		this.finishTimeAfternoonSecond = null;
		this.startMenuSecond = false;
		this.finishMenuSecond = false;
		this.finishTimeMenuMorningSecond = false;
		this.startTimeMenuMorningSecond = false;
		this.finishTimeMenuAfternoonSecond = false;
		this.startTimeMenuAfternoonSecond = false;

		this.responsabilitaCivile = "";
		this.assicurazioneAzienda = "";
		this.inizioPeriodoUnoMenu = false;
		this.dataInizioSospensioneUno = "";
		this.finePeriodoUnoMenu = false;
		this.dataFineSospensioneUno = "";
		this.motivazioneSospensioneUno = "";
		this.inizioPeriodoDueMenu = false;
		this.dataInizioSospensioneDue = "";
		this.finePeriodoDueMenu = false;
		this.dataFineSospensioneDue = "";
		this.motivazioneSospensioneDue = "";
		this.indennitaMensile = "";
		this.docDVR = null;
	}

	reset() {
		this.accept = "";
		this.startDate = "";
		this.finishDate = "";
		this.currentDay = "";
		this.startDateTemp = "";
		this.finishDateTemp = "";
		this.currentDateTemp = new Date().toISOString().substr(0, 10);
		this.startTimeMorning = null;
		this.finishTimeMorning = null;
		this.startTimeAfternoon = null;
		this.finishTimeAfternoon = null;
		this.startMenu = false;
		this.finishMenu = false;
		this.finishTimeMenuMorning = false;
		this.startTimeMenuMorning = false;
		this.finishTimeMenuAfternoon = false;
		this.startTimeMenuAfternoon = false;

		this.hasSecondPeriod = false;
		this.startDateSecond = "";
		this.finishDateSecond = "";
		this.startDateTempSecond = "";
		this.finishDateTempSecond = "";
		this.startTimeMorningSecond = null;
		this.finishTimeMorningSecond = null;
		this.startTimeAfternoonSecond = null;
		this.finishTimeAfternoonSecond = null;
		this.startMenuSecond = false;
		this.finishMenuSecond = false;
		this.finishTimeMenuMorningSecond = false;
		this.startTimeMenuMorningSecond = false;
		this.finishTimeMenuAfternoonSecond = false;
		this.startTimeMenuAfternoonSecond = false;

		this.responsabilitaCivile = "";
		this.assicurazioneAzienda = "";
		this.inizioPeriodoUnoMenu = false;
		this.dataInizioSospensioneUno = "";
		this.finePeriodoUnoMenu = false;
		this.dataFineSospensioneUno = "";
		this.motivazioneSospensioneUno = "";
		this.inizioPeriodoDueMenu = false;
		this.dataInizioSospensioneDue = "";
		this.finePeriodoDueMenu = false;
		this.dataFineSospensioneDue = "";
		this.motivazioneSospensioneDue = "";
		this.indennitaMensile = "";
		this.docDVR = null;
	}

	created() {
		var payload = {
			idAzienda: this.info.idAzienda
		};
		data
			.dispatchEnterpriseTutors(this["$store"], payload)
			.then(result => {
				result.forEach(element => {
					this.tutorList.push({
						idTutor: element.idUtente,
						nomeTutor: element.cognomeUtente + " " + element.nomeUtente
					});
				});

				this.loadAttivitaFromIscrizioneAzienda()
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	loadAttivitaFromIscrizioneAzienda() {
		var payload = {
			idIscrizioneAzienda: this.info.idIscrizioneAttivita
		}
		data.dispatchGetAttivitaFromIscrizioneAzienda(this["$store"], payload)
			.then(result => {
				this.dateStartingEvent = result.dataInizio;
				this.dateFinishingEvent = result.dataFine;
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	convertToBase64(file: File): Promise<string> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = () => {
				const result = reader.result as string;
				resolve(result.split(",")[1]);
			};
			reader.onerror = (error) => reject(error);

			reader.readAsDataURL(file);
		});
	}
}
